import React from "react";
import { nanoid } from "nanoid";
import LOGO from "../../../Assets/images/logo/logoNavbar.png";
import {connect} from "react-redux";

function PrintContent({ data, startDate, endDate, branchs, user }) {
  const hideCost = localStorage.getItem('show_shipment_cost') === "0" && localStorage.getItem('superkey') === 'credit';
  const service = localStorage.getItem('superkey') === 'service';
  const staff = localStorage.getItem('superkey') === 'staff';
  var date = new Date();
  var amont = 0;
  var shipmentSum = 0;
  var codSum = 0;
  var servicSum = 0;
  data.map((value) => {
    amont = amont + parseInt(value.num_parcel);
    shipmentSum = shipmentSum + parseInt(value.shipment_cost);
    codSum = parseInt(value.cod_cost) === 0 || parseInt(value.cod_cost) > 0 ? codSum + parseInt(value.cod_cost) : codSum + 0;
    servicSum = servicSum + parseInt(value.service_cod);
  });

  return (
    <div style={{ margin: "15px" }}>
      <div style={{ textAlign: "center" }}>
        <h2>ใบคุมสินค้า</h2>
      </div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "10px" }}>
        <div style={{ justifyContent: "start" }}>
          <b>วันที่พิมพ์ : </b>{" "}
          {(date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) +
            "/" +
            (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
            "/" +
            date.getFullYear()}{" "}
          <br />
          <b>วันที่รับสินค้า : </b> {startDate} ถึงวันที่ {endDate}
          <br />
          <b>รหัสลูกค้า : {branchs} </b>
        </div>
        <div style={{ justifyContent: "end" }}>
          <img src={LOGO} alt="logo porlor" style={{ width: "150px", height: "70px" }} />
          <div style={{ marginTop: "10px" }}>บริษัท​ ปอ​ลอ เอ็กซ์เพ​รส​ จํากัด</div>
        </div>
      </div>
      {localStorage.getItem('superkey')==='credit' ? (
        <table style={{ border:"none"  }}>
        <thead>
          <tr>
            <th style={{ textAlign: "center", border: "none", margin: "0px", padding:"0px" }}>ลำดับ</th>
            {/* <th style={{ width: "10%", textAlign: "center" }}>เลข​ที่​ใบขน​ส่ง​/Order/สําหรับลูกค้า/หมายเลขinvoice</th> */}
            <th style={{ border:"none", width: "10%", textAlign: "center" }}>เลขที่co note</th>
            <th style={{ border:"none",  width: "10%", textAlign: "center" }}>เลข​ที่​ใบขน​ส่ง​</th>
            <th style={{ border:"none", width: "10%", textAlign: "center" }}>หมายเลขinvoice</th>
            <th style={{ border:"none", width: "10%", textAlign: "center" }}>เอกสารนำกลับ</th>
            <th style={{ border:"none", textAlign: "center" }}>เวลา</th>
            <th style={{ border:"none", width: "10%", textAlign: "center" }}>ชื่อผู้รับ</th>
            <th style={{ border:"none", textAlign: "center" }}>เขต/อำเภอ</th>
            <th style={{ border:"none", textAlign: "center" }}>จังหวัด</th>
            <th style={{ border:"none", textAlign: "center" }}>รหัสไปรณีย์</th>
            {/* <th style={{ border:"none", textAlign: "center" }}>ชิ้น</th> */}
            {/* {hideCost || service || staff ? "":
            (
              <th style={{ width: "100px", textAlign: "center" }}>ค่าขนส่ง</th> 
            )} */}
            <th style={{ width: "100px", textAlign: "center", border:"none" }}>COD/บาท</th>
            {/* <th style={{ width: "100px", textAlign: "center" }}>ค่าบริการ</th> */}
            {/* {hideCost || service || staff ? "":
            (
              <th style={{ width: "100px", textAlign: "center" }}>ยอดสุทธิ (บาท)</th> 
            )} */}
            <th style={{ width: "100px", textAlign: "center", border:"none" }}>หมายเหตุ</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, index) => (
            <tr key={nanoid()}>
              <td style={{ border:"none" , margin: "0px", padding:"0px"}} >{index + 1}</td>
              <td style={{ textAlign: "center", border: "none"}}>
              {value.ref_no === null || value.ref_no === '0' ? " " : 
              <div>{value.ref_no}</div>
              }
              </td>
              <td style={{ border:"none"  }}>
                {value.awb_code}
              </td>
              <td style={{ border:"none"  }}>
                {value.invoice === null || value.invoice === '' ? " " : <div>{value.invoice}</div>}
              </td>
              <td style={{ border:"none"  }}>
                {/* เอกสารนำกลับ: {value.num_return_doc} */}
                {value.num_return_doc}
              </td>
              <td style={{ border:"none"  }}>{value.created_date.substring(11, 16)}</td>
              <td style={{ border:"none"  }}>{value.receiver_name}</td>
              <td style={{ border:"none"  }}>{value.receiver_amphur}</td>
              <td style={{ border:"none"  }}>{value.receiver_province}</td>
              <td style={{ border:"none" }}>{value.awb_code.substring(11, 16)}</td>

              {/* <td style={{ textAlign: "center", border: "none" }}>{value.num_parcel}</td> */}
              {/* {hideCost || service || staff ? "":
              (
                <td style={{ textAlign: "right" }}>
                {(parseFloat(value.shipment_cost)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </td>
              )} */}
              <td style={{ textAlign: "right", border: "none" }}>
                {parseInt(value.cod_cost) === 0 || parseInt(value.cod_cost) > 0
                  ? parseInt(value.cod_cost).toLocaleString(undefined, { minimumFractionDigits: 2 })
                  : parseInt(0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </td>
              {/* <td style={{ textAlign: "right" }}>
                {parseInt(value.service_cod).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </td> */}
              {/* {hideCost || service || staff ? "":
              (
                <td style={{ textAlign: "right" }}>
                {(parseFloat(value.service_cod) + parseFloat(value.shipment_cost)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </td>
              )} */}
              <td style={{ border:"none"  }}>{value.note}</td>
            </tr>
          ))}
          <tr>
            <td colspan="6" style={{ textAlign: "center" }}>
              ยอดรวม
            </td>
            <td style={{ textAlign: "center"  }}>{amont}</td>
            {/* {hideCost || service || staff? "":
            (
              <td style={{ textAlign: "right" }}>{shipmentSum.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            )} */}
            <td style={{ textAlign: "right" }}>{codSum.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            {/* <td style={{ textAlign: "right" }}>{servicSum.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            {hideCost || service || staff ? "":
            (
              <td style={{ textAlign: "right" }}>{(servicSum + shipmentSum).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            )} */}
            
            {/* <td></td> */}
          </tr>
        </tbody>
      </table>
      ):(
        <table>
        <thead>
          <tr>
            <th style={{ width: "3%", textAlign: "center",border:"none",margin: "0px", padding:"0px"  }}>ลำดับ</th>
            {/* <th style={{ width: "15%", textAlign: "center",border:"none"  }}>เลข​ที่​ใบขน​ส่ง​/Order/สําหรับลูกค้า</th> */}
            <th style={{ border:"none", width: "10%", textAlign: "center" }}>เลขที่co note</th>
            <th style={{ border:"none",  width: "10%", textAlign: "center" }}>เลข​ที่​ใบขน​ส่ง​</th>
            <th style={{ border:"none", width: "10%", textAlign: "center" }}>หมายเลขinvoice</th>
            <th style={{ border:"none", width: "3%", textAlign: "center" }}>เอกสารนำกลับ</th>
            <th style={{ textAlign: "center",border:"none"  }}>เวลา</th>
            <th style={{  textAlign: "center",border:"none",width: "10%"  }}>ชื่อผู้รับ</th>
            <th style={{ textAlign: "center",border:"none"  }}>เขต/อำเภอ</th>
            <th style={{ textAlign: "center",border:"none"  }}>จังหวัด</th>
            {/* <th style={{ textAlign: "center",border:"none"  }}>ชิ้น</th> */}
            <th style={{ textAlign: "center",border: "none" }}>รหัสไปรณีย์</th>
            {hideCost || service || staff ? "":
            (
              <th style={{ width: "80px", textAlign: "center",border:"none"  }}>ค่าขนส่ง</th>
            )}
            <th style={{ width: "80px", textAlign: "center",border:"none"  }}>COD/บาท</th>
            <th style={{ width: "80px", textAlign: "center",border:"none"  }}>ค่าบริการ</th>
            {hideCost || service || staff ? "":
            (
              <th style={{ width: "80px", textAlign: "center",border:"none"  }}>ยอดสุทธิ (บาท)</th> 
            )}
            <th style={{ width: "80px", textAlign: "center",border:"none", marginRight:'1px' }}>หมายเหตุ</th>
          </tr>
        </thead>
        <tbody>
          {data.map((value, index) => (
            <tr key={nanoid()}>
              <td style={{ width: "3%",border:"none",margin: "0px", padding:"0px"  }}>{index + 1}</td>
              <td style={{ textAlign: "center", border: "none"}}>
                {value.ref_no === null || value.ref_no === '0' ? " " : 
                <div>{value.ref_no}</div>
                }
              </td>
              <td style={{ border:"none"  }}>
                {value.awb_code}
              </td>
              <td style={{ border:"none"  }}>
                {value.invoice === null || value.invoice === '' ? " " : <div>{value.invoice}</div>}
              </td>
              <td style={{ border:"none"  }}>
                {/* เอกสารนำกลับ: {value.num_return_doc} */}
                {value.num_return_doc}
              </td>

              <td style={{ border:"none"  }}>{value.created_date.substring(11, 16)}</td>
              <td style={{ border:"none"  }}>{value.receiver_name}</td>
              <td style={{ border:"none"  }}>{value.receiver_amphur}</td>
              <td style={{ border:"none"  }}>{value.receiver_province}</td>
              <td style={{ border:"none"  }}>{value.awb_code.substring(11, 16)}</td>
              {/* <td style={{ textAlign: "center" ,border:"none"}}>{value.num_parcel}</td> */}
              {hideCost || service || staff ? "":
              (
                <td style={{ textAlign: "right",border:"none" }}>
                {(parseFloat(value.shipment_cost)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </td>
              )}
              <td style={{ textAlign: "right",border:"none" }}>
                {parseInt(value.cod_cost) === 0 || parseInt(value.cod_cost) > 0
                  ? parseInt(value.cod_cost).toLocaleString(undefined, { minimumFractionDigits: 2 })
                  : parseInt(0).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </td>
              <td style={{ textAlign: "right",border:"none" }}>
                {parseInt(value.service_cod).toLocaleString(undefined, { minimumFractionDigits: 2 })}
              </td>
              {hideCost || service || staff ? "":
              (
                <td style={{ textAlign: "right" ,border:"none"}}>
                {(parseFloat(value.service_cod) + parseFloat(value.shipment_cost)).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                </td>
              )}
              <td style={{ border:"none"  }}>{value.note}</td>
            </tr>
          ))}
          <tr>
            <td colspan="10" style={{ textAlign: "center" }}>
              ยอดรวม
            </td>
            {/* <td style={{ textAlign: "center" }}>{amont}</td> */}
            {hideCost || service || staff ? "":
            (
              <td style={{ textAlign: "right" }}>{shipmentSum.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            )}
            <td style={{ textAlign: "right" }}>{codSum.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            <td style={{ textAlign: "right" }}>{servicSum.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            {hideCost || service || staff ? "":
            (
              <td style={{ textAlign: "right" }}>{(servicSum + shipmentSum).toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
            )}
            {/* <td></td> */}
          </tr>
        </tbody>
      </table>
      )}
      
      <div style={{ display: "flex", justifyContent: "center", marginTop: "70px" }}>
        <div style={{ marginRight: "50%", textAlign: "center" }}>
          ลงชื่อ​ผู้ส่ง​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.
          <p>........../........../..........</p>
        </div>
        <div style={{ textAlign: "center" }}>
          ลงชื่อ​ผู้​ขน​ส่ง​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.​.
          <p>........../........../..........</p>​
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.Authentication,
});

export default connect(mapStateToProps)(PrintContent);
